import { HttpErrorResponse } from '@angular/common/http';
import { Retailer, MetaData } from '@emi/shared/models';
import { createAction, props } from '@ngrx/store';

export const getRetailers = createAction('[RetailerFilters] Get Retailers');

export const getRetailersSuccess = createAction(
    '[RetailerFilters] Get Retailers Success',
    props<{ retailers: Retailer[]; metadata: MetaData | null; searchText: string | null }>()
);

export const getRetailersFailure = createAction('[RetailerFilters] Get Retailers Failure', props<{ error: HttpErrorResponse }>());

export const fetchRetailers = createAction('[RetailerFilters] Fetch Retailers');

export const searchRetailers = createAction('[RetailerFilters] Get Retailers With Search', props<{ searchText: string; delay: number }>());

export const isLoadingRetailers = createAction('[RetailerFilters] Loading Retailers');

export const amendRetailerSelections = createAction('[RetailerFilters] Amend Selected Retailers');

export const getNextPageRetailers = createAction('[RetailerFilters] Get Next Page Retailers');

export const updateRetailersSelectionSuccess = createAction(
    '[RetailerFilters] Get Next Page Retailers Success',
    props<{ retailers: Retailer[]; metadata: MetaData | null }>()
);
